import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import uniqueId from 'lodash/uniqueId';
import Modal from '../../../components/modal/index';
import { Tick } from '../../../helpers/icon-dictionary';
import UploadSummary from '../../../components/upload-summary/index';
import messages from '../messages';
import css from '../index.scss';

const RollOverResult = (props) => {
    const { isRolloverDone,
        intl,
        rolloverSummary,
        onViewRollOverSummary
    } = props;

    const GenerateResultRow = () => (<div className={css.resultContainer} key={uniqueId('rolloverResult')}>
        {intl.formatMessage(messages.rollOverHasCompleted)}
        <div className={css.resultSection}>
            <div> {rolloverSummary.newStudents.length} {intl.formatMessage(messages.newStudents)}</div>
            <div> {rolloverSummary.updatedStudents.length} {intl.formatMessage(messages.updatedStudents)}</div>
            <div> {rolloverSummary.unassignedStudents.length} {intl.formatMessage(messages.unassignedStudents)}</div>
            <div> {rolloverSummary.transferredStudents.length} {intl.formatMessage(messages.transferredStudents)}</div>
        </div>
        <div className={css.resultSection}>
            <div> {rolloverSummary.newTeachers.length} {intl.formatMessage(messages.newTeachers)}</div>
            <div> {rolloverSummary.updatedTeachers.length} {intl.formatMessage(messages.updatedTeachers)}</div>
        </div>
        <div className={css.resultSection}>
            <div> {rolloverSummary.newClassrooms.length} {intl.formatMessage(messages.newClasses)}</div>
            <div> {rolloverSummary.updatedClassrooms.length} {intl.formatMessage(messages.updatedClasses)}</div>
        </div>
    </div>);

    return (<Modal show={isRolloverDone}>
        <UploadSummary
            handleOnViewSummary={onViewRollOverSummary}
            icon={Tick}
            message={intl.formatMessage(messages.rolloverComplete)}
            rollOverConfirmationPage>{GenerateResultRow()}</UploadSummary>
    </Modal>);
};

RollOverResult.propTypes = {
    intl: intlShape.isRequired,
    isRolloverDone: PropTypes.bool,
    rolloverSummary: PropTypes.object,
    onViewRollOverSummary: PropTypes.func
};

export default injectIntl(RollOverResult);



// WEBPACK FOOTER //
// ./app/components/roll-over/modals/results.js